import { useState, useEffect, useCallback } from 'react';

export const useOKXPriceOnly = () => {
  const [btcPrice, setBtcPrice] = useState(null);
  const [bidAskSpread, setBidAskSpread] = useState(0);
  const [volume24h, setVolume24h] = useState(0);
  const [isLive, setIsLive] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);

  const fetchOKXPrice = useCallback(async () => {
    try {
      const response = await fetch('https://www.okx.com/api/v5/market/ticker?instId=BTC-USDT');
      const data = await response.json();
      
      if (data.code === '0' && data.data?.[0]) {
        const ticker = data.data[0];
        const price = parseFloat(ticker.last);
        const spread = parseFloat(ticker.askPx) - parseFloat(ticker.bidPx);
        const volume = parseFloat(ticker.vol24h);
        
        setBtcPrice(price);
        setBidAskSpread(spread);
        setVolume24h(volume);
        setIsLive(true);
        setIsConnected(true);
        setLastUpdate(new Date().toISOString());
        
        console.log(`📊 OKX Price Feed: $${price.toFixed(2)} | Spread: $${spread.toFixed(2)}`);
      }
    } catch (error) {
      console.error('❌ OKX price fetch failed:', error);
      setIsLive(false);
      setIsConnected(false);
    }
  }, []);

  useEffect(() => {
    fetchOKXPrice();
    const interval = setInterval(fetchOKXPrice, 2000);
    return () => clearInterval(interval);
  }, [fetchOKXPrice]);

  return {
    btcPrice,
    bidAskSpread,
    volume24h,
    isLive,
    isConnected,
    lastUpdate
  };
};
